// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
import "typeface-catamaran"

require ('./src/components/styles.css')